import isAdditionalEquipment from '~/src/features/full-buy/helpers/ab/isAdditionalEquipment';
import { IFlow } from '~/src/features/full-buy/store/initialState';
import { ESteps } from '~/src/features/full-buy/types';

/**
 * Проверка адреса после выбора тарифа
 */
export const traditionFlow: IFlow = {
    name: 'traditionFlow',
    steps: [
        ESteps.tariffInfo,
        ESteps.equipments,
        ESteps.equipmentsCottage,
        ESteps.equipmentsTv,
        ESteps.address,
        ESteps.contacts,
        ESteps.agreementCreated,
        ESteps.timeSlots,
        ESteps.final,
    ],
};

/**
 * Проверка адреса на первом шаге
 */
export const notTraditionFlow: IFlow = {
    name: 'FirstAddressSteps',
    steps: [
        ESteps.address,
        ESteps.subscriptions,
        ESteps.equipments,
        ESteps.equipmentsCottage,
        ESteps.equipmentsTv,
        ESteps.contacts,
        ESteps.agreementCreated,
        ESteps.timeSlots,
        ESteps.final,
    ],
};

/**
 * Логика последовательности шагов
 * Логика пропуска и объединения шагов реализована в контейнерах
 *
 * Если ЧС, то убираем шаг с выбором роутеров.
 * Если не ЧС и включен аб-тест скрытия шагов оборудования, то убираем роутеры и декодеры.
 * Если не ЧС и включен аб-тест отображение доп оборудования, то убираем роутеры и декодеры.
 *
 */
const getFlow = (
    isAddressVerificationOnFirstStep = false,
    isCottage?: boolean,
) => {
    const flow = isAddressVerificationOnFirstStep ? notTraditionFlow : traditionFlow;

    if (isCottage) {
        const stepsWithoutRouters = flow.steps.filter(step => step !== ESteps.equipments);

        return {
            ...flow,
            steps: stepsWithoutRouters,
        };
    } else {

        let needToExclude = [ESteps.equipmentsCottage];

        if (isAdditionalEquipment()) {
            needToExclude = [...needToExclude, ESteps.equipments, ESteps.equipmentsTv];
        }

        return {
            ...flow,
            steps: flow.steps.filter(step => !needToExclude.includes(step)),
        };
    }
};

export default getFlow;
